import "./styles.less";


import { Button, Skeleton, Space } from "antd";

import React from "react";
import { usePropertyCoverTag } from "./hook";
import { useTheme } from "../../../../Styles/ThemeHook";

export const PropertyCoverTags = ({
	onClick,
	imageCount,
	files,
	youtube,
	latitude,
	tour3d,
	loading,
}) => {
	const { has_map, has_video, has_floorPlans, has_tour3d } = usePropertyCoverTag({
		latitude,
		files,
		youtube,
		tour3d,
	});	
	const { theme } = useTheme();

	const onTabClick = (e, tab) => {
		e.stopPropagation();
		onClick(tab);
	};

	if (loading)
		return (
			<Space size={theme.spacing.smSpacing}>
				{[...Array(3)].map((o, i) => (
					<Skeleton
						key={"property-cover-tags_sk_" + i}
						title={false}
						active
						round
						paragraph={{ rows: 1, width: 50, style: { margin: 0 } }}
					/>
				))}
			</Space>
		);


	return (<>
		<div className="pd-property-cover-tags" > {/* El contenedor de las opciones */}

			{imageCount > 0 && (
				<Button className={'secondary'} onClick={e => onTabClick(e, "photos")}>Galería</Button>		
			)}

			{has_video && (
				<Button className={'secondary'} onClick={e => onTabClick(e, "video")}>Video</Button>		
			)}
			{has_map && (
				<Button className={'secondary'} onClick={e => onTabClick(e, "map")}>Mapa</Button>		
			)}
			{has_floorPlans && (
				<Button className={'secondary'} onClick={e => onTabClick(e, "floorPlans")}>Planos</Button>		
			)}

			{has_tour3d && (
				<Button className={'secondary'} onClick={e => onTabClick(e, "tour3d")}>Tour 3d</Button>		
			)}
		</div>
	</>);
};
